import { request } from "./client";
import { formatCommentTimestamp } from "../utils/time";

export function normalizeComment(c) {
  if (!c) return c;
  const prof = c.profile ?? c.user?.profile ?? c.author?.profile ?? {};
  const u = c.user ?? c.author ?? {};
  const author = {
    id: c.userId ?? u.id ?? prof.id ?? "",
    name: prof.fullName ?? u.fullName ?? u.name ?? "Anonymous",
    handle: prof.username
      ? `@${prof.username}`
      : u.username
        ? `@${u.username}`
        : "",
    avatar: prof.avatarUrl ?? u.avatarUrl ?? u.avatar ?? "",
    badge: prof.verifiedBadge ?? u.verifiedBadge ?? null,
  };
  return {
    ...c,
    author,
    timestamp: formatCommentTimestamp(c.createdAt),
    likes: c.likesCount ?? c.likes ?? 0,
    isLiked: c.isLiked ?? c.likedByMe ?? c.liked ?? false,
    replyCount: c.commentCount ?? c.replyCount ?? 0,
    replies: (c.replies ?? []).map(normalizeComment),
  };
}

export const getComments = (postId, parentCommentId = null) =>
  request(
    `/comment?postId=${postId}&limit=100${parentCommentId ? `&parentCommentId=${parentCommentId}` : ""}`,
  ).then((data) => {
    const raw = Array.isArray(data)
      ? data
      : Array.isArray(data.data)
        ? data.data
        : (data.comments ?? []);
    return raw.map(normalizeComment);
  });

export const createComment = (postId, content) =>
  request("/comment", {
    method: "POST",
    body: JSON.stringify({ postId, content }),
  });

export const createReply = (postId, commentId, content) =>
  request("/comment", {
    method: "POST",
    body: JSON.stringify({ postId, parentCommentId: commentId, content }),
  });

export const updateComment = async (commentId, content) => {
  try {
    return await request(`/comment/${commentId}`, {
      method: "PATCH",
      body: JSON.stringify({ content }),
    });
  } catch (err) {
    if (err?.status === 404 || err?.status === 405 || err?.status === 400) {
      return request(`/comment/${commentId}`, {
        method: "PUT",
        body: JSON.stringify({ content }),
      });
    }
    throw err;
  }
};

export const deleteComment = (commentId) =>
  request(`/comment/${commentId}`, { method: "DELETE" });

export const likeComment = (commentId) =>
  request(`/comment/${commentId}/like`, { method: "POST" }).catch(() => {});
